import React from 'react';

// Three-card "Why Invest in Outdoor Shading" section. All copy
// baked in — these are general value-prop messages not tied to
// per-customer settings.
export default function WhyInvestSection() {
  return (
    <section className="asg-why">
      <div className="asg-why-inner">
        <div className="asg-why-header asg-reveal">
          <p className="asg-section-label">Why Invest in Outdoor Shading</p>
          <h2 className="asg-section-title">
            More than shade - it's added<br />value to your home.
          </h2>
        </div>
        <div className="asg-why-grid">
          <div className="asg-why-card asg-reveal">
            <div className="asg-why-icon">&uarr;</div>
            <h3>Space You Actually Use</h3>
            <p>
              Usable outdoor living space is consistently one of the features Melbourne buyers
              value most. A quality awning or pergola extends the floor area you actually use,
              improves how the property presents, and does it for a fraction of the cost of
              building out.
            </p>
          </div>
          <div className="asg-why-card asg-reveal">
            <div className="asg-why-icon">&#9728;</div>
            <h3>Year-Round Melbourne Living</h3>
            <p>
              Melbourne's weather is unpredictable. With a motorised retractable awning or
              louvered/retractable pergola roof, you control sunlight, airflow and rain
              protection on demand - turning your outdoor area into a space you'll use
              every day, in every season.
            </p>
          </div>
          <div className="asg-why-card asg-reveal">
            <div className="asg-why-icon">&#9678;</div>
            <h3>Engineered for Australia</h3>
            <p>
              Every ASG system uses premium aluminium alloy with a multi-layer protective
              coating, structurally rated for Australian wind loads. No timber rot, no rust,
              no repainting - just lasting performance in any climate.
            </p>
          </div>
        </div>
        <div className="asg-frame-cta asg-reveal">
          <a href="#quote" className="asg-btn-primary">Request a Quote</a>
        </div>
      </div>
    </section>
  );
}
